import { defineStore } from "pinia";
import API from "../api/index";

export const usePaymentChannelsStore = defineStore("paymentChannels", {
  
  state: () => ({
    
    channels: [],
    
    isLoading: false,
  
  }),

  actions: {
    
    async fetch_channels() {

      this.isLoading = true;
      
      const res = await API.get_payment_channels();
      
      this.channels = res.data || [];
    
      this.isLoading = false;
    
    },
  
    add_channel_to_store(new_channel) {
      this.channels.push(new_channel);
    },

    update_channel_in_store(updated_channel) {
      const index = this.channels.findIndex(c => c.id === updated_channel.id);
      if (index !== -1) {
        this.channels[index] = { ...this.channels[index], ...updated_channel };
      }
    },

    remove_channel_from_store(id) {
      this.channels = this.channels.filter(c => c.id !== id);
    }

  }

})